import Hubspot from '../../services/Hubspot';

export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('DowloadGuideTypeAndEntitiesForm', () => ({
        inputs: {
          firstname: '',
          email: '',
          intent_path: '',
          terms_agree: false,
        },
        errors: {},
        showMessage: false,
        successMessage: true,
        errorMessage: false,
        onHandleChange(fieldName, value) {
          this.inputs[fieldName] = value;
        },
        validateField(fieldName) {
          delete this.errors[fieldName];
          switch (fieldName) {
            case 'firstname':
              if (!this.inputs.firstname.trim()) {
                this.errors.firstname = 'Please complete this required field.';
              } else if (!/^[A-Za-z0-9 ]+$/.test(this.inputs.firstname)) {
                this.errors.firstname =
                  'Must only contain letters, numbers, and spaces.';
              } else if (this.inputs.firstname.length > 50) {
                this.errors.firstname = 'Must be less than 50 characters.';
              }
              break;

            case 'email':
              if (!this.inputs.email.trim()) {
                this.errors.email = 'Please complete this required field.';
              } else if (!this.validateEmail(this.inputs.email)) {
                this.errors.email = 'Email must be formatted correctly.';
              }
              break;

            case 'terms_agree':
              if (!this.inputs.terms_agree) {
                this.errors.terms_agree =
                  'Please complete this required field.';
              }
              break;

            case 'intent_path':
              if (!this.inputs.intent_path) {
                this.errors.intent_path = 'Please select and option.';
              }
              break;

            default:
              break;
          }
        },

        validateAll() {
          this.errors = {};

          Object.keys(this.inputs).forEach((fieldName) => {
            this.validateField(fieldName);
          });
        },

        validateEmail(email) {
          const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return re.test(email.toLowerCase());
        },

        async submitForm() {
          this.validateAll();
          if (Object.keys(this.errors).length > 0) {
            return;
          }

          const payload = {
            firstname: this.inputs.firstname,
            email: this.inputs.email,
            intent_path: this.inputs.intent_path,
          };

          try {
            const { data } =
              await Hubspot.submitDownloadGuideTypesAndEntities(payload);

            if (data?.data || data.includes('Form submitted successfully')) {
              this.showMessage = true;
              this.successMessage =
                data?.data?.inlineMessage || 'Thanks for submitting the form.';
              this.errorMessage = false;
              this.resetForm();
            } else {
              this.showMessage = true;
              this.successMessage = '';
              this.errorMessage = 'Failed to submit form, try again.';
            }
          } catch (error) {
            this.showMessage = true;
            this.successMessage = '';
            this.errorMessage = 'Failed to submit form, try again.';
          }
        },

        resetForm() {
          this.inputs.firstname = '';
          this.inputs.email = '';
          this.inputs.intent_path = '';
          this.inputs.terms_agree = false;
          this.errors = {};
        },
      }));
    });
  },
};
